<template>
  <div class="ceiling-wrap">
    <span @click="handleAccept" class="copy-writing-text">{{ copywriting }}</span>
    <div class="iconfont iconcha" @click="closeShowSuction"></div>
  </div>
</template>
<script>
import mixin from './mixin';
import bus from 'common/bus';
import trackReportMixin from '../Common/CommonMixin/trackReport'

export default {
  mixins: [mixin, trackReportMixin],
  methods: {
    closeShowSuction() {
      this.$emit('closeCeiling')
    },
    handleAccept() {
      // console.log(item)
      if (this.skip === '_blank') { // 功能性跳转
        // 埋点上报
        this.buttonTrackReport({
          buttonName: 'toShowDiagnosis',
        });
        if (!this.isLogin) {
          // bus.$emit('login', {triggerSource: 'diagnosis'});
          bus.$emit('login', { triggerSource: 'appointment' });
          return
        }
        // bus.$emit('toShowDiagnosis', { type: 1})
        bus.$emit('toShowDiagnosis')
      }
      if (this.skip === '_self') { // 自定义链接跳转
        if (this.skipWay === '_blank') { // 在当前页面打开
          window.location.href = this.skipLink;
        }
        if (this.skipWay === '_self') { // 在新标签页打开
          window.open(this.skipLink, '_blank');
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.ceiling-wrap {
  position: relative;
  width: 100%;
  height: 24px;
  background: #BEBEBE;
  font-size: 12px;
  font-family: Roboto-Light;
  font-weight: 300;
  text-decoration: underline;
  color: #333333;
  display: flex;
  align-items: center;
  justify-content: center;

  .copy-writing-text {
    cursor: pointer;
  }

  .iconcha {
    position: absolute;
    color: #FFFFFF;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }
}
</style>
